import React from "react";
import Dialog, { DialogProps } from "components/Dialog";
import { SimplePlanPackageDetails, TicketDetails } from "features/types";
import { Text } from "@ui-kitten/components";
import { View } from "react-native";
import { useCalculateRefundQuery } from "queries/ticket.queries";
import { useAccount } from "hooks/useAccount";
import InnerLoading from "components/InnerLoading";
import i18n from "plugins/localization";
import { formatCurrency } from "utils/appUtils";

interface RefundDialogProps extends DialogProps {
  tickets: TicketDetails[];
  planPackage: SimplePlanPackageDetails | null;
}

const RefundDialog: React.FC<RefundDialogProps> = ({
  visible,
  setVisible,
  tickets,
  planPackage,
  ...rest
}) => {
  const { account } = useAccount();
  const { data: ticketCartDetails, isFetching: loading } =
    useCalculateRefundQuery({
      accountId: account!.id,
      ticketIds: tickets.map((ticket) => ticket.id),
    });

  return (
    <Dialog visible={visible} setVisible={setVisible} {...rest}>
      <View style={{ minHeight: 100 }}>
        <Text category="h6" style={{ marginBottom: 15 }}>
          Refund
        </Text>
        {loading && <InnerLoading text="" />}
        {ticketCartDetails && (
          <View
            style={{
              justifyContent: "center",
              flex: 1,
            }}
          >
            {Number(ticketCartDetails.totalPoints) > 0 && (
              <Text>
                {i18n.t("screens.EventDetail.bankRefund", {
                  amount: formatCurrency(ticketCartDetails.totalPoints, {
                    priceType: ticketCartDetails.priceType,
                  }),
                })}
              </Text>
            )}
            {Number(ticketCartDetails.totalCredits) > 0 && (
              <Text>
                {i18n.t("screens.EventDetail.accountCreditRefund", {
                  amount: formatCurrency(ticketCartDetails.totalCredits),
                })}
              </Text>
            )}
            {Number(ticketCartDetails.totalCreditCardCharges) > 0 && (
              <Text>
                {i18n.t("screens.EventDetail.amountToBeRefunded", {
                  amount: formatCurrency(
                    ticketCartDetails.totalCreditCardCharges
                  ),
                })}
              </Text>
            )}
            {planPackage && planPackage.refundType === "BALANCE" && (
              <Text category="c1">
                Credit will be returned to your account for future use.
              </Text>
            )}
          </View>
        )}
      </View>
    </Dialog>
  );
};

export default RefundDialog;
